import { z } from 'zod';

export const docMigrationSchema = z.object({
  /**
   * The current (stringified) document that is in the database. Once the pending doc has been applied
   * then it may be desirable to roll back to this document.
   */
  doc: z.string(),
  docId: z.string(),
  docType: z.string(),
  /** The pending document that will be applied */
  pendingDoc: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type DocMigration = z.output<typeof docMigrationSchema>;

export const docMigrationCvxSchema = docMigrationSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type DocMigrationCvx = z.output<typeof docMigrationCvxSchema>;
